import React from 'react';
export function Footer() {
  return <footer className="bg-primary border-t border-border py-12" data-id="element-69">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-70">
        <div className="flex flex-col items-center md:items-start" data-id="element-71">
          <span className="font-serif text-xl text-text-light tracking-wide" data-id="element-72">
            THE MBA COMPANY
          </span>
          <a href="https://www.criticalfuture.ai" target="_blank" rel="noopener noreferrer" className="text-[10px] text-text-muted tracking-widest uppercase mt-1 hover:text-accent hover:underline transition-colors" data-id="element-73">
            by Critical Future
          </a>
        </div>

        <div className="text-sm text-text-muted text-center md:text-right" data-id="element-74">
          <p data-id="element-75">
            &copy; {new Date().getFullYear()} The MBA Company. All rights
            reserved.
          </p>
          <a href="https://www.criticalfuture.ai" target="_blank" rel="noopener noreferrer" className="mt-1 text-xs text-text-muted/60 hover:text-accent hover:underline transition-colors block" data-id="element-76">
            A Critical Future Initiative.
          </a>
        </div>
      </div>
    </footer>;
}